import React from 'react';
import { FormChangesUI } from '@praktio/common-ui';

import './SubpageHeader.scss';

interface IProps {
  title?: string;
  children?: React.ReactNode;
  savedChanges?: boolean;
  unsavedChanges?: boolean;
}

const SubpageHeader = ({ title, children, savedChanges, unsavedChanges }: IProps) => (
  <div className="SubpageHeader d-flex justify-content-between align-items-center sticky-top">
    <div className="SubpageHeader-title">{title}</div>
    <div className="SubpageHeader-right-content">
      <FormChangesUI savedChanges={savedChanges} unsavedChanges={unsavedChanges}>
        {children}
      </FormChangesUI>
    </div>
  </div>
);

export { SubpageHeader };
